import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Wrapper, Text } from "./styled";
import LogInLayout from "../../commons/LogInLayout";
import { TITLE } from "./constants";
import { temporaryLogOut } from "../../../store/Users/actions";

const AwaitingConfirmation = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(temporaryLogOut());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LogInLayout>
      <Wrapper>
        <Text>{TITLE}</Text>
      </Wrapper>
    </LogInLayout>
  );
};

export default AwaitingConfirmation;
